import React from 'react';
import {StyleSheet, View} from 'react-native';
import Icon from '@assets/icon';

const SplashScreen = () => (
  <View style={[styles.container,]}>
    <Icon />
  </View>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: 'black',
    flex: 1,
    justifyContent: 'center',
    padding: 10,
  },
});

export default SplashScreen;